import { injector } from "@/services";
import { NETWORK_ERROR } from "../../../constants/network-error";
import { useSystemStore } from "../../store";
import { ECommonMessages } from "../../../types";
import { NotifyPlugin } from "draivn-ui-kit";
import {
  EErrorType,
  type ErrorService,
  type IApiError,
} from "draivn-ui-domain";
import { watch } from "vue";
import { I18N_SERVICE_INJECTION_KEY } from "@/constants";
import { storeToRefs } from "pinia";

export const localNetworkDisplayHandlerInit = (errorService: ErrorService) => {
  const i18n = injector.injectFromRoot(I18N_SERVICE_INJECTION_KEY);
  const localNetworkErrorDisplayHandler = (error: IApiError) => {
    const isInternetError = (error.data[0] as Error).message === NETWORK_ERROR;
    if (isInternetError) {
      const { t } = i18n.global;
      errorService.blockDisplay();
      const $systemStore = useSystemStore();
      const { healthStatus } = storeToRefs($systemStore);
      const closeNotify = NotifyPlugin.create({
        type: "draivn-toast-warning",
        message: t(ECommonMessages.ERROR_INTERNET_TITLE),
        caption: t(ECommonMessages.ERROR_INTERNET_MESSAGE),
        spinner: true,
      });
      watch(healthStatus, (value: boolean) => {
        if (value) {
          closeNotify();
          errorService.unblockDisplay();
        }
      });
    }
  };

  errorService.registerErrorDisplay(EErrorType.LOCAL, {
    display: localNetworkErrorDisplayHandler,
  });
};
